import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  return <Reveal className={`${align === 'center' ? 'text-center' : 'text-left'} ${className}`} data-id="element-210" data-mp="3jzx1zt8adwm8">
      {eyebrow && <p className="font-sans text-[0.6rem] uppercase tracking-luxe text-gold" data-id="element-211" data-mp="bjtwnu4nck12">{eyebrow}</p>}
      <h2 className="mt-4 font-display text-[2.1rem] font-light leading-[1.15] text-ink sm:text-4xl lg:text-[2.9rem]" data-id="element-212" data-mp="gj6t96lbl5gu">
        {title}
      </h2>
      <span aria-hidden="true" className={`mt-7 block h-[1px] w-16 bg-goldsoft ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-213" data-mp="1u0wrqdv9tcn" />
    </Reveal>;
}